// import React, { useState, useEffect, useRef } from "react";
// import wpImg from "./images/frame.png";
// //card1 animation image 
// import frameImg1 from './images/frameImg1.png';
// import frameImg2 from './images/frameImg2.png';
// import frameImg3 from './images/frameImg3.png';
// import frameImg4  from './images/frameImg4.png';

// const CARDS = [
//     {
//         title: "WhatsApp Payments",
//         desc:
//             "Enable secure in-chat payments and checkout, allowing users to complete transactions without leaving WhatsApp.",
//     },
//     {
//         title: "WhatsApp Business Calling",
//         desc:
//             "Seamlessly switch from chat to voice with integrated calling, making complex queries easier to resolve in real time.",
//     },
//     {
//         title: "Click-to-WhatsApp (CTW)",
//         desc:
//             "Turn ads, websites or social media links into instant WhatsApp conversations, boosting lead generation and conversions.",
//     },
//     {
//         title: "Web View",
//         desc:
//             "Offer immersive mini-web experiences inside WhatsApp for product details, forms or checkout flows without redirecting users.",
//     },
//     {
//         title: "Schedule Appointments (Forms Flow)",
//         desc:
//             "Collect customer details, book slots and confirm appointments using guided multi-step forms directly in chat.",
//     },
//     {
//         title: "View Catalog",
//         desc:
//             "Showcase your full product or service catalog inside WhatsApp with pricing and details for easy browsing and instant purchase.",
//     },
//     {
//         title: "Carousel Messages",
//         desc:
//             "Send interactive, swipeable cards with images, titles and buttons- perfect for product discovery and promotions.",
//     },
//     {
//         title: "Analytics & CRM Integration",
//         desc:
//             "Get real-time insights into every interaction with seamless CRM sync for streamlined workflows and smarter engagement.",
//     },
// ];

// const MainWhatsApp = () => {
//     const cardCount = CARDS.length; // 8
//     const [mounted, setMounted] = useState(false);
//     const [step, setStep] = useState(0); // sequence step index
//     const [imageAttachSide, setImageAttachSide] = useState("left"); // 'left' or 'right' attach glow
//     const sectionRef = useRef(null);

//     // NEW: measure columns to match phone height
//     const leftColRef = useRef(null);
//     const rightColRef = useRef(null);
//     const [phoneH, setPhoneH] = useState(550);

//     // Split indexes
//     const leftIdx = [0, 2, 4, 6];
//     const rightIdx = [1, 3, 5, 7];

//     // Build chained sequence: L0 -> IMG -> L2 -> IMG -> ... -> R1 -> IMG -> ...
//     const sequence = React.useMemo(() => {
//         const chain = [];
//         leftIdx.forEach((i) => {
//             chain.push({ type: "card", index: i, side: "left" });
//             chain.push({ type: "img" });
//         });
//         rightIdx.forEach((i) => {
//             chain.push({ type: "card", index: i, side: "right" });
//             chain.push({ type: "img" });
//         });
//         return chain;
//     }, [leftIdx, rightIdx]);

//     // Reveal when section enters viewport
//     useEffect(() => {
//         const el = sectionRef.current;
//         if (!el) return;
//         const io = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting) {
//                     setMounted(true);
//                     io.disconnect();
//                 }
//             },
//             { threshold: 0.2 }
//         );
//         io.observe(el);
//         return () => io.disconnect();
//     }, []);

//     // Chain advance (card -> image -> next ...)
//     useEffect(() => {
//         if (!mounted) return;
//         const id = setInterval(() => {
//             setStep((s) => (s + 1) % sequence.length);
//         }, 2000);
//         return () => clearInterval(id);
//     }, [mounted, sequence.length]);

//     // Track attach side for phone glow based on current card
//     useEffect(() => {
//         const current = sequence[step];
//         if (current?.type === "card") {
//             setImageAttachSide(current.side);
//         }
//     }, [step, sequence]);

//     // Measure column heights and sync phone height
//     useEffect(() => {
//         const measure = () => {
//             const lh = leftColRef.current?.offsetHeight || 0;
//             const rh = rightColRef.current?.offsetHeight || 0;
//             const h = Math.max(lh, rh);
//             if (h && h !== phoneH) setPhoneH(h);
//         };
//         const onResize = () => requestAnimationFrame(measure);

//         // first paint
//         const id = setTimeout(measure, 0);
//         // also when images/fonts settle
//         window.addEventListener("resize", onResize);
//         return () => {
//             clearTimeout(id);
//             window.removeEventListener("resize", onResize);
//         };
//     }, [phoneH, mounted]);

//     // Base card skin
//     const cardStyles = {
//         background: "linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%)",
//         padding: "20px",
//         borderRadius: "8px",
//         boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//         position: "relative",
//         zIndex: 1,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//     };

//     // Helpers to compute active states
//     const isCardActive = (i) => {
//         const current = sequence[step];
//         return current?.type === "card" && current.index === i;
//     };
//     const isImageActive = () => {
//         const current = sequence[step];
//         return current?.type === "img";
//     };

//     return (
//         <section
//             ref={sectionRef}
//             className="py-5 position-relative"
//             style={{
//                 overflow: "hidden",
//                 background: "linear-gradient(180deg, #e3efffff 0%, #FFFFFF 100%)",
//                 marginTop: 80,
//             }}
//         >
//             <div
//                 className="px-5 x-xxl-5 px-6 mx-auto position-relative"
//                 style={{ maxWidth: "74%", zIndex: 1 }}
//             >
//                 {/* Heading */}
//                 <div className={`reveal from-top ${mounted ? "show" : ""}`} style={{ "--delay": "0ms" }}>
//                     <h2
//                         style={{
//                             fontSize: "2.5rem",
//                             fontFamily: "Inter",
//                             fontWeight: 700,
//                             color: "#242121ff",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Why Start with{" "}
//                         <span
//                             style={{
//                                 color: "#1DB954", 
//                                 fontFamily: "Inter",
//                                 fontWeight: 700,
//                             }}
//                         >
//                             WhatsApp Business API?
//                         </span>
//                     </h2>

//                     <p
//                         className="mt-2"
//                         style={{
//                             marginTop: -2,
//                             color: "#413e3eff",
//                             fontSize: "1.1rem",
//                             fontFamily: "Poppins",
//                             fontWeight: 300,
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Engage smarter with features designed to convert chats into sales and customers into loyal users.
//                     </p>
//                 </div>

//                 {/* Columns + Center Phone */}
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         gap: "2rem",
//                         marginTop: "4rem",
//                     }}
//                 >
//                     {/* Left Column */}
//                     <div
//                         ref={leftColRef}
//                         className={`reveal from-left ${mounted ? "show" : ""}`}
//                         style={{
//                             "--delay": "120ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[0, 2, 4, 6].map((i) => (
//                             <div key={i} className={`card-animation-wrapper ${isCardActive(i) ? "active" : ""}`}>
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                             fontFamily: "Lato",
//                                         }}
//                                     >
//                                         {CARDS[i].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[i].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Center Image (auto height to match columns) */}
//                     <div
//                         className={`reveal from-top ${mounted ? "show" : ""}`}
//                         style={{
//                             "--delay": "220ms",
//                             flexShrink: 0,
//                             margin: "0 2rem",
//                             width: "350px",
//                             height: phoneH,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <div
//                             className={`phone-frame ${isImageActive() ? `active attach-${imageAttachSide}` : ""}`}
//                             style={{ width: 350, height: phoneH }} // override default height
//                         >
//                             <img src={wpImg} alt="WhatsApp Preview" className="phone-img" />
//                         </div>
//                     </div>

//                     {/* Right Column */}
//                     <div
//                         ref={rightColRef}
//                         className={`reveal from-right ${mounted ? "show" : ""}`}
//                         style={{
//                             "--delay": "320ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[1, 3, 5, 7].map((i) => (
//                             <div key={i} className={`card-animation-wrapper ${isCardActive(i) ? "active" : ""}`}>
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontFamily: "Lato",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                         }}
//                                     >
//                                         {CARDS[i].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[i].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Styles */}
//             <style>{`
//         /* ====== Mount reveal animations ====== */
//         .reveal {
//           opacity: 0;
//           transform: translateY(-12px);
//           transition: opacity .6s ease, transform .6s ease;
//           will-change: transform, opacity;
//           transition-delay: var(--delay, 0ms);
//         }
//         .reveal.from-left { transform: translateX(-26px); }
//         .reveal.from-right { transform: translateX(26px); }
//         .reveal.from-top { transform: translateY(-22px); }
//         .reveal.show { opacity: 1; transform: none; }

//         /* ====== Card wrapper with animated gradient border ====== */
//         .card-animation-wrapper {
//           position: relative;
//           padding: 2px;
//           border-radius: 12px;
//           overflow: hidden;
//           transition: all 0.5s ease-in-out;
//           height: 140px;
//           will-change: transform, box-shadow;
//         }
//         .card-animation-wrapper::before,
//         .card-animation-wrapper::after {
//           z-index: 0; /* keep pseudo-elements behind content */
//         }
//         .card-animation-wrapper::before {
//           content: "";
//           position: absolute;
//           inset: 0;
//           background: transparent;
//           border-radius: inherit;
//         }
//         .card-animation-wrapper.active::before {
//           background: conic-gradient(from 0deg, #4FC3FF, #2C2C6F, #4FC3FF);
//           animation: spin 2.5s linear infinite;
//         }
//         .card-animation-wrapper::after {
//           content: "";
//           position: absolute;
//           inset: 5px;
//           background: linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%);
//           border-radius: 10px;
//           transition: background 0.5s ease-in-out;
//         }
//         .card-animation-wrapper.active {
//           animation: borderPop .45s cubic-bezier(.2,.8,.2,1) both;
//         }
//         @keyframes borderPop {
//           0%   { transform: scale(.985); box-shadow: 0 0 0 rgba(76,195,255,0); }
//           45%  { transform: scale(1.02); box-shadow: 0 12px 28px rgba(76,195,255,.25); }
//           100% { transform: scale(1);    box-shadow: 0 6px 16px rgba(0,0,0,.08); }
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }

//         /* ====== Phone frame (animated border) ====== */
//         .phone-frame {
//           position: relative;
//           border-radius: 10px;
//           padding: 2px;         
//           overflow: hidden;
//           transition: box-shadow .3s ease;
//         }
//         .phone-frame::before {
//           content: "";
//           position: absolute;
//           inset: 0;
//           border-radius: 12px;
//           background: transparent; /* turns on when .active */
//           z-index: 0;
//         }
//         // .phone-frame.active::before {
//         //   background: conic-gradient(from 0deg, #4FC3FF, #2C2C6F, #4FC3FF);
//         //   animation: spin 2.5s linear infinite;
//         }
//         .phone-frame::after {
//           content: "";
//           position: absolute;
//           inset: 5px;
//           border-radius: 10px;
//         //   background: #ffffff;
//           z-index: 1;
//         }
//         .phone-img {
//           position: relative;
//           z-index: 2; 
//           width: 100%;
//           height: 100%;
//           object-fit: contain;
//           border-radius: 10px;
//           display: block;
//         }

//         // /* Edge attach glow when image is active */
//         // .phone-frame.active.attach-left .phone-img  { box-shadow: -8px 0 18px rgba(79,195,255,.35); }
//         // .phone-frame.active.attach-right .phone-img { box-shadow:  8px 0 18px rgba(79,195,255,.35); }
//       `}</style>
//         </section>
//     );
// };

// export default MainWhatsApp;


/*******************************************************************************************************************************************/



// import React, { useState, useEffect, useRef } from "react";
// // card1
// import wpImg from "./images/frame.png";
// import frameImg1 from "./images/frameImg1.png";
// import frameImg2 from "./images/frameImg2.png";
// import frameImg3 from "./images/frameImg3.png";
// import frameImg4 from "./images/frameImg4.png";
// // card2
// import frame2 from "./images/Card_Frame2.png";
// import sendMessage from "./images/card2_Send Message.png";
// import frame2Img from "./images/card2_frame1.png";
// import frameImg5 from "./images/frameImg5.png";
// import frameImg6 from "./images/frameImg6.png";
// import frameImg7 from "./images/frameImg7.png";
// import frameImg8 from "./images/frameImg8.png";
// import frameImg9 from "./images/frameImg9.png";
// import frameImg10 from "./images/frameImg10.png";
// // card3
// import frame3Img from "./images/Card_Frame3.png";
// import frameImg11 from "./images/frameImg11.png";
// import frameImg12 from "./images/frameImg12.png";


// import img1 from './images/img1.png';
// import img2 from './images/img2.png';
// import img3 from './images/img3.png';
// import img4 from './images/img4.png';
// import img5 from './images/img5.png';
// import img6 from './images/img6.png';
// import img7 from './images/img7.png';
// const CARDS = [
//     { title: "WhatsApp Payments", desc: "Enable secure in-chat payments and checkout, allowing users to complete transactions without leaving WhatsApp." },
//     { title: "WhatsApp Business Calling", desc: "Seamlessly switch from chat to voice with integrated calling, making complex queries easier to resolve in real time." },
//     { title: "Click-to-WhatsApp (CTW)", desc: "Turn ads, websites or social media links into instant WhatsApp conversations, boosting lead generation and conversions." },
//     { title: "Web View", desc: "Offer immersive mini-web experiences inside WhatsApp for product details, forms or checkout flows without redirecting users." },
//     { title: "Schedule Appointments (Forms Flow)", desc: "Collect customer details, book slots and confirm appointments using guided multi-step forms directly in chat." },
//     { title: "View Catalog", desc: "Showcase your full product or service catalog inside WhatsApp with pricing and details for easy browsing and instant purchase." },
//     { title: "Carousel Messages", desc: "Send interactive, swipeable cards with images, titles and buttons- perfect for product discovery and promotions." },
//     { title: "Analytics & CRM Integration", desc: "Get real-time insights into every interaction with seamless CRM sync for streamlined workflows and smarter engagement." },
// ];

// const MainWhatsApp = () => {
//     const [mounted, setMounted] = useState(false);
//     const [imageStep, setImageStep] = useState(0); // card1 sequence
//     const [phase, setPhase] = useState("card1");   // "card1" | "card2" | "card3"
//     const [card2Step, setCard2Step] = useState(0); // card2 steps
//     const [card3Step, setCard3Step] = useState(0); // card3 steps
//     const [showF4, setShowF4] = useState(false);   // Frame 4 (0.8s after Frame 3)
//     const [showF10, setShowF10] = useState(false); // Frame 10 (0.8s after Frame 9)

//     const sectionRef = useRef(null);
//     const leftColRef = useRef(null);
//     const rightColRef = useRef(null);
//     const [phoneH, setPhoneH] = useState(550);

//     // Reveal when section enters viewport
//     useEffect(() => {
//         const el = sectionRef.current;
//         if (!el) return;
//         const io = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting) {
//                     setMounted(true);
//                     io.disconnect();
//                 }
//             },
//             { threshold: 0.1 }
//         );
//         io.observe(el);
//         return () => io.disconnect();
//     }, []);

//     // CARD 1 sequence (unchanged logic) + 0.8s delayed Frame4 + settle AFTER F4
//     useEffect(() => {
//         if (!mounted || phase !== "card1") return;
//         const timers = [];
//         setImageStep(0);
//         setShowF4(false);

//         timers.push(setTimeout(() => setImageStep(1), 0));        // frameImg1
//         timers.push(setTimeout(() => setImageStep(2), 1600));     // frameImg2
//         timers.push(
//             setTimeout(() => {
//                 setImageStep(3);                                      // frameImg3
//                 timers.push(setTimeout(() => setShowF4(true), 1000));  // 0.8s later -> frameImg4
//             }, 1600 + 1800)
//         );
//         // settle AFTER frameImg4 appears
//         timers.push(setTimeout(() => setImageStep(4), 1600 + 1800 + 1200)); // was +700

//         // total (keep same) -> switch to card2
//         const total = 1600 + 1800 + 700 + 900; // ~5.0s
//         timers.push(setTimeout(() => setPhase("card2"), total));

//         return () => timers.forEach(clearTimeout);
//     }, [mounted, phase]);

//     // CARD 2 sequence (same timings you had)
//     useEffect(() => {
//         if (!mounted || phase !== "card2") return;
//         const base = 50;
//         const timers = [];
//         setCard2Step(0);
//         setShowF10(false);

//         timers.push(setTimeout(() => setCard2Step(1), base));                       // frame2
//         timers.push(setTimeout(() => setCard2Step(2), base + 1500));                // +1.5s sendMessage
//         timers.push(setTimeout(() => setCard2Step(3), base + 1500 + 1000));         // +1.0s frame2Img
//         timers.push(setTimeout(() => setCard2Step(4), base + 1500 + 1000 + 500));
//         timers.push(setTimeout(() => setCard2Step(5), base + 1500 + 1000 + 1000));
//         timers.push(setTimeout(() => setCard2Step(6), base + 1500 + 1000 + 2000));
//         timers.push(setTimeout(() => setCard2Step(7), base + 1500 + 1000 + 2500));
//         timers.push(setTimeout(() => setCard2Step(8), base + 1500 + 1000 + 3000));  // F9

//         // after card2 finishes, go to card3 (keep overall hold similar)
//         timers.push(
//             setTimeout(() => {
//                 setCard2Step(0);
//                 setPhase("card3");
//             }, base + 1500 + 1000 + 2500 + 1200)
//         );

//         return () => timers.forEach(clearTimeout);
//     }, [mounted, phase]);

//     // Show F10 (right fade) exactly 0.8s after F9 appears
//     useEffect(() => {
//         if (phase !== "card2") return;
//         let t;
//         if (card2Step === 8) {
//             setShowF10(false);
//             t = setTimeout(() => setShowF10(true), 800);
//         }
//         return () => t && clearTimeout(t);
//     }, [card2Step, phase]);


//     useEffect(() => {
//         if (!mounted || phase !== "card3") return;
//         const timers = [];
//         setCard3Step(0);

//         const base = 60;
//         timers.push(setTimeout(() => setCard3Step(1), base));                   // frame3Img pop
//         timers.push(setTimeout(() => setCard3Step(2), base + 500));             // +0.5s -> frameImg11
//         timers.push(setTimeout(() => setCard3Step(3), base + 500 + 1000));      // +1.0s -> re-pop frame3Img (hide 11)
//         timers.push(setTimeout(() => setCard3Step(4), base + 500 + 1000 + 500));// +0.5s -> frameImg12

//         // hold a bit then loop back to card1
//         timers.push(
//             setTimeout(() => {
//                 setCard3Step(0);
//                 setShowF4(false);
//                 setShowF10(false);
//                 setPhase("card1");
//                 setImageStep(0);
//             }, base + 500 + 1000 + 500 + 1200)
//         );

//         return () => timers.forEach(clearTimeout);
//     }, [mounted, phase]);

//     // Measure column heights and sync phone height
//     useEffect(() => {
//         const measure = () => {
//             const lh = leftColRef.current?.offsetHeight || 0;
//             const rh = rightColRef.current?.offsetHeight || 0;
//             const h = Math.max(lh, rh);
//             if (h && h !== phoneH) setPhoneH(h);
//         };
//         const onResize = () => requestAnimationFrame(measure);
//         const id = setTimeout(measure, 0);
//         window.addEventListener("resize", onResize);
//         return () => {
//             clearTimeout(id);
//             window.removeEventListener("resize", onResize);
//         };
//     }, [phoneH, mounted]);

//     const cardStyles = {
//         background: "linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%)",
//         padding: "20px",
//         borderRadius: "8px",
//         position: "relative",
//         zIndex: 1,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//     };

//     const isCardActive = (i) => {
//         if (!mounted) return false;
//         if (phase === "card1") return i === 0 && imageStep < 4;
//         if (phase === "card2") return i === 2;
//         // (no change requested for card3 highlight)
//         return false;
//     };

//     return (
//         <section
//             ref={sectionRef}
//             className={`py-5 position-relative section-reveal ${mounted ? "show" : ""}`}
//             style={{
//                 overflow: "hidden",
//                 background: "linear-gradient(180deg, #e3efffff 0%, #FFFFFF 100%)",
//                 // marginTop: 80,
//             }}
//         >
//             <div
//                 className="px-5 x-xxl-5 px-6 mx-auto position-relative"
//                 style={{ maxWidth: "74%", zIndex: 1 }}
//             >
//                 {/* Heading */}
//                 <div className="reveal from-top" style={{ "--delay": "0ms" }}>
//                     <h2
//                         style={{
//                             fontSize: "2.5rem",
//                             fontFamily: "Inter",
//                             fontWeight: 700,
//                             color: "#242121ff",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Why Start with{" "}
//                         <span style={{ color: "#1DB954", fontFamily: "Inter", fontWeight: 700 }}>
//                             WhatsApp Business API?
//                         </span>
//                     </h2>
//                     <p
//                         className="mt-2"
//                         style={{
//                             marginTop: -2,
//                             color: "#413e3eff",
//                             fontSize: "1.1rem",
//                             fontFamily: "Poppins",
//                             fontWeight: 300,
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Engage smarter with features designed to convert chats into sales
//                         and customers into loyal users.
//                     </p>
//                 </div>

//                 {/* Columns + Center Phone */}
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         gap: "2rem",
//                         marginTop: "4rem",
//                     }}
//                 >
//                     {/* Left Column */}
//                     <div
//                         ref={leftColRef}
//                         className="reveal from-left"
//                         style={{
//                             "--delay": "120ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[0, 2, 4, 6].map((i) => (
//                             <div
//                                 key={i}
//                                 className={`card-animation-wrapper ${isCardActive(i) ? "active" : ""}`}
//                             >
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                             fontFamily: "Lato",
//                                         }}
//                                     >
//                                         {CARDS[i].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[i].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Center Image (auto height to match columns) */}
//                     <div
//                         className="reveal from-top"
//                         style={{
//                             "--delay": "220ms",
//                             flexShrink: 0,
//                             margin: "0 2rem",
//                             width: "350px",
//                             height: phoneH,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <div className="phone-frame" style={{ width: 350, height: phoneH }}>
//                             {/* BG image — fades out when card2 starts */}
//                             <img
//                                 src={wpImg}
//                                 alt="WhatsApp Preview"
//                                 className={`phone-img phone-img-bg ${phase !== "card1" ? "bg-out" : ""}`}
//                             />

//                             {/* Overlay content: phase-based */}
//                             <div className="phone-img-overlay">
//                                 {/* CARD 1 */}
//                                 {phase === "card1" && (
//                                     <>
//                                         {imageStep === 1 && (
//                                             <img
//                                                 key="frameImg1"
//                                                 src={frameImg1}
//                                                 alt="Frame 1"
//                                                 className="phone-img fade-from-bottom"
//                                                 style={{
//                                                     width: "100%",
//                                                 }}
//                                             />
//                                         )}
//                                         {imageStep === 2 && (
//                                             <img
//                                                 key="frameImg2"
//                                                 src={frameImg2}
//                                                 alt="Frame 2"
//                                                 className="phone-img fade-from-right"
//                                                 style={{ width: "100%" }}
//                                             />
//                                         )}
//                                         {imageStep === 3 && (
//                                             <div className="phone-img-container">
//                                                 {/* Frame 3: left fade */}
//                                                 <img
//                                                     key="frameImg3"
//                                                     src={frameImg3}
//                                                     alt="Frame 3"
//                                                     className="phone-img fade-left"
//                                                     style={{ height: "40%", marginBottom: "10px" }}
//                                                 />
//                                                 {/* Frame 4: right fade, 0.8s after Frame 3 */}
//                                                 {showF4 && (
//                                                     <img
//                                                         key="frameImg4"
//                                                         src={frameImg4}
//                                                         alt="Frame 4"
//                                                         className="phone-img fade-right"
//                                                         style={{ height: "40%" }}
//                                                     />
//                                                 )}
//                                             </div>
//                                         )}
//                                     </>
//                                 )}

//                                 {/* CARD 2 */}
//                                 {phase === "card2" && (
//                                     <>
//                                         {/* frame2 shows until swapped to frame2Img */}
//                                         {card2Step >= 1 && card2Step < 3 && (
//                                             <img
//                                                 key="card2-frame2"
//                                                 src={frame2}
//                                                 alt="Card2 Frame"
//                                                 className="phone-img fade-scale-in"
//                                             />
//                                         )}

//                                         {/* sendMessage appears 1.5s after frame2 */}
//                                         {card2Step >= 2 && card2Step < 3 && (
//                                             <img
//                                                 key="card2-send"
//                                                 src={sendMessage}
//                                                 alt="Send Message"
//                                                 className="phone-img pop-bounce"
//                                                 style={{
//                                                     width: "55%",
//                                                     height: "auto",
//                                                     position: "absolute",
//                                                     bottom: "20%",
//                                                     right: "-1%",
//                                                 }}
//                                             />
//                                         )}

//                                         {/* base becomes frame2Img after swap */}
//                                         {card2Step >= 3 && (
//                                             <>
//                                                 <img
//                                                     key="card2-frame2img"            // static key so it doesn't remount
//                                                     src={frame2Img}
//                                                     alt="Card2 Frame (Alt)"
//                                                     className={`phone-img ${card2Step === 3 ? "fade-scale-in" : ""}`}
//                                                 /* fade only once at step === 3, then stay fixed */
//                                                 />

//                                                 {/* stacked items inside frame2Img area (no overlap, normal size) */}
//                                                 <div className="frame2-stack">
//                                                     {card2Step >= 4 && (
//                                                         <img
//                                                             src={frameImg5}
//                                                             alt="F5"
//                                                             className="stack-item left fade-left"
//                                                             style={{ width: "60%", marginLeft: "7.3rem" }}
//                                                         />
//                                                     )}
//                                                     {card2Step >= 5 && (
//                                                         <img
//                                                             src={frameImg6}
//                                                             alt="F6"
//                                                             className="stack-item right fade-right"
//                                                             style={{ width: "80%", marginRight: "3.6rem" }}
//                                                         />
//                                                     )}
//                                                     {card2Step >= 6 && (
//                                                         <img
//                                                             src={frameImg7}
//                                                             alt="F7"
//                                                             className="stack-item left fade-left"
//                                                             style={{ width: "70%", marginLeft: "5rem" }}
//                                                         />
//                                                     )}
//                                                     {card2Step >= 7 && (
//                                                         <img
//                                                             src={frameImg8}
//                                                             alt="F8"
//                                                             className="stack-item right fade-right"
//                                                             style={{ width: "80%", marginRight: "3.6rem" }}
//                                                         />
//                                                     )}
//                                                     {card2Step >= 8 && (
//                                                         <img
//                                                             src={frameImg9}
//                                                             alt="F9"
//                                                             className="stack-item left fade-left"
//                                                             style={{ width: "60%", marginLeft: "7.4rem" }}
//                                                         />
//                                                     )}
//                                                     {showF10 && (
//                                                         <img
//                                                             src={frameImg10}
//                                                             alt="F10"
//                                                             className="stack-item right fade-right"
//                                                             style={{ width: "70%", marginRight: "5.2rem" }}
//                                                         />
//                                                     )}
//                                                 </div>
//                                             </>
//                                         )}
//                                     </>
//                                 )}

//                                 {/* CARD 3 */}
//                                 {phase === "card3" && (
//                                     <>
//                                         {/* frame3 base image (animate on initial and on re-pop) */}
//                                         {card3Step >= 1 && (
//                                             <img
//                                                 key={`card3-base-${card3Step >= 3 ? "repop" : "base"}`}
//                                                 src={frame3Img}
//                                                 alt="Card3 Frame"
//                                                 className="phone-img fade-scale-in"
//                                             />
//                                         )}

//                                         {/* When step == 2, show frameImg11 inside the frame */}
//                                         {card3Step === 2 && (
//                                             <div className="frame3-stack">
//                                                 <img
//                                                     src={frameImg11}
//                                                     alt="F11"
//                                                     className="stack3-item fade-scale-in"
//                                                     style={{ width: "85%" }}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* After re-pop (step >= 3), if step >= 4 show frameImg12 inside */}
//                                         {card3Step >= 3 && (
//                                             <div className="frame3-stack">
//                                                 {card3Step >= 4 && (
//                                                     <img
//                                                         src={frameImg12}
//                                                         alt="F12"
//                                                         className="stack3-item fade-scale-in"
//                                                         style={{ width: "85%" }}
//                                                     />
//                                                 )}
//                                             </div>
//                                         )}
//                                     </>
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right Column */}
//                     <div
//                         ref={rightColRef}
//                         className="reveal from-right"
//                         style={{
//                             "--delay": "320ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[1, 3, 5, 7].map((i) => (
//                             <div
//                                 key={i}
//                                 className={`card-animation-wrapper ${isCardActive(i) ? "active" : ""}`}
//                             >
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontFamily: "Lato",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                         }}
//                                     >
//                                         {CARDS[i].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[i].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Styles */}
//             <style>{`
//         /* ====== Section reveal animation ====== */
//         .section-reveal {
//           opacity: 0;
//           transform: translateY(-50px);
//           transition: opacity 0.8s ease, transform 0.8s ease;
//         }
//         .section-reveal.show { opacity: 1; transform: none; }

//         /* ====== Mount reveal animations ====== */
//         .reveal {
//           opacity: 0;
//           transform: translateY(-12px);
//           transition: opacity .6s ease, transform .6s ease;
//           will-change: transform, opacity;
//           transition-delay: var(--delay, 0ms);
//         }
//         .reveal.from-left { transform: translateX(-26px); }
//         .reveal.from-right { transform: translateX(26px); }
//         .reveal.from-top { transform: translateY(-22px); }
//         .section-reveal.show .reveal { opacity: 1; transform: none; }

//         /* ====== Card wrapper with animated gradient border ====== */
//         .card-animation-wrapper {
//           position: relative;
//           padding: 2px;
//           border-radius: 12px;
//           overflow: hidden;
//           transition: all 0.5s ease-in-out;
//           height: 140px;
//           will-change: transform, box-shadow;
//         }
//         .card-animation-wrapper::before,
//         .card-animation-wrapper::after { z-index: 0; }
//         .card-animation-wrapper::before {
//           content: "";
//           position: absolute;
//           inset: 0;
//           background: transparent;
//           border-radius: inherit;
//         }
//         .card-animation-wrapper.active::before {
//           background: conic-gradient(from 0deg, #4FC3FF, #2C2C6F, #4FC3FF);
//           animation: spin 2.5s linear infinite;
//         }
//         .card-animation-wrapper::after {
//           content: "";
//           position: absolute;
//           inset: 5px;
//           background: linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%);
//           border-radius: 10px;
//           transition: background 0.5s ease-in-out;
//         }
//         .card-animation-wrapper.active {
//           animation: borderPop .45s cubic-bezier(.2,.8,.2,1) both;
//         }
//         @keyframes borderPop {
//           0%   { transform: scale(.985); box-shadow: 0 0 0 rgba(76,195,255,0); }
//           45%  { transform: scale(1.02); box-shadow: 0 12px 28px rgba(76,195,255,.25); }
//           100% { transform: scale(1);    box-shadow: 0 6px 16px rgba(0,0,0,.08); }
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }

//         /* ====== Phone frame ====== */
//         .phone-frame {
//           position: relative;
//           border-radius: 10px;
//           padding: 2px;
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//         }
//         .phone-img-bg {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           border-radius: 8px;
//           z-index: 1;
//           transition: opacity .4s ease;
//         }
//         .phone-img-bg.bg-out { opacity: 0; }

//         .phone-img-overlay {
//           position: relative;
//           z-index: 2;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//         }
//         .phone-img {
//           width: 100%;
//           height: 100%;
//           maxwidth: 100px;
//           object-fit: contain;
//           border-radius: 8px;
//           display: block;
//         }

//         .phone-img.fade-from-bottom { top: 3rem; animation: fadeFromBottom 0.6s ease forwards; }
//         .phone-img.fade-from-right  { top: 2rem; animation: fadeFromRight  0.6s ease forwards; }

//         .phone-img-container {
//           top: 1.2rem;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           width: 100%;
//           height: 100%;
//           justify-content: center;
//         }

//         @keyframes fadeFromBottom { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes fadeFromRight  { from { opacity: 0; transform: translateX(30px); } to { opacity: 1; transform: translateX(0); } }

//         /* Left/Right helpers (used by Frame3/4 and F9/F10) */
//         .fade-left  { animation: fadeLeft 420ms ease forwards; }
//         .fade-right { animation: fadeRight 420ms ease forwards; }
//         @keyframes fadeLeft  { from { opacity:0; transform: translateX(-26px); } to { opacity:1; transform:none; } }
//         @keyframes fadeRight { from { opacity:0; transform: translateX( 26px); } to { opacity:1; transform:none; } }

//         /* ===================== Overlay images tuning ===================== */
//         .phone-img-overlay img[alt="Frame 1"] { width: 100%;   max-height: 90%; margin-top: -20px; object-fit: contain; }
//         .phone-img-overlay img[alt="Frame 2"] { width: 84%; max-height: 84%; margin-top: 24px; object-fit: contain; }

//         .phone-img-container {
//           position: relative;
//           top: 4.5rem;
//           display: flex;
//           flex-direction: column;
//           align-items: flex-start;
//           justify-content: flex-start;
//           gap: 12px;
//           width: 100%;
//           height: 100%;
//         }
//         .phone-img-container img[alt="Frame 3"] { width: 60%; height: auto !important; margin-left: 7rem; margin-top: 5px; }
//         .phone-img-container img[alt="Frame 4"] { width: 60%; height: auto !important; margin-left: 2rem; margin-top: 2px; }

//         /* ====== Card 2 animations ====== */
//         .fade-scale-in { animation: fadeScaleIn 420ms cubic-bezier(.2,.8,.2,1) forwards; }
//         @keyframes fadeScaleIn { from { opacity: 0; transform: scale(.92); } to { opacity: 1; transform: scale(1); } }
//         .pop-bounce { animation: popBounce 360ms cubic-bezier(.2,.8,.2,1) forwards; }
//         @keyframes popBounce { 0% { opacity: 0; transform: translateY(12px) scale(.94); } 60% { opacity: 1; transform: translateY(-2px) scale(1.02); } 100% { opacity: 1; transform: translateY(0) scale(1); } }

//         /* ====== Inside frame2Img: stacked items (no overlap) ====== */
//         .frame2-stack {
//           position: absolute;
//           inset: 12% 8% 14% 8%;
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//           align-items: stretch;
//           pointer-events: none;
//         }
//         .stack-item { width: 88%; height: auto; border-radius: 10px; object-fit: contain; }
//         .stack-item.left  { align-self: flex-start; }
//         .stack-item.right { align-self: flex-end; }

//         /* ====== Inside frame3Img (card3) ====== */
//         .frame3-stack {
//           position: absolute;
//           inset: 12% 8% 14% 8%;
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//           align-items: center;
//           pointer-events: none;
//         }
//         .stack3-item { width: 88%; height: auto; border-radius: 10px; object-fit: contain; }


//         .phone-img-overlay img[alt="Frame 1"]{
//   /* size */
//   width: 86% !important;
//   height: auto !important;
//   max-height: 80%;
//   /* position */
//   margin-top: 28px !important;   /* ↓ move down */
//   margin-left: auto !important;
//   margin-right: auto !important;
//   display: block;
//   /* look */
//   object-fit: contain !important;
//   border-radius: 12px;            /* matches screen rounding */
// }
// /* remove animation's extra top offset for accurate placement */
// .phone-img-overlay img[alt="Frame 1"].fade-from-bottom{ top: 0 !important; }

// /* Frame 2 (Payment methods) — a touch larger + slightly down */
// .phone-img-overlay img[alt="Frame 2"]{
//   width: 90% !important;
//   height: auto !important;
//   max-height: 80%;
//   margin-top: 18px !important;   /* ↓ move down a little */
//   margin-left: auto !important;
//   margin-right: auto !important;
//   display: block;
//   object-fit: contain !important;
//   border-radius: 12px;
// }
// .phone-img-overlay img[alt="Frame 2"].fade-from-right{ top: 0 !important; }

// /* make section a stacking context */
// .section-reveal {
//   position: relative;
// }

// /* top-only blend that matches your current #e3efff → #fff background */
// .section-reveal::before {
//   content: "";
//   position: absolute;
//   left: 0; right: 0; top: 0;
//   height: 160px;                   /* adjust thickness if desired */
//   pointer-events: none;
//   z-index: 0;
//   background: linear-gradient(
//     to bottom,
//     rgba(227, 239, 255, 0.90) 0%,  /* #e3efff tint at top */
//     rgba(227, 239, 255, 0.55) 45%,
//     rgba(227, 239, 255, 0.00) 100%
//   );
// }
// .section-reveal {
//   background: linear-gradient(180deg, #f1f7ff 0%, #FFFFFF 100%) !important;
// }

//       `}</style>
//         </section>
//     );
// };

// export default MainWhatsApp;

/*********************************************************************************************************************************************/




// import React, { useState, useEffect, useRef } from "react";

// import img1 from "./images/img1.png";
// import img12 from "./images/img12.png";
// import img13 from "./images/img13.png";
// import img2 from "./images/img2.png";
// import img21 from "./images/img21.png";
// import img3 from "./images/img3.png";
// import img31 from "./images/img31.png";
// import img4 from "./images/img4.png";
// import img5 from "./images/img5.png";
// import img51 from "./images/img51.png";
// import img6 from "./images/img6.png";
// import img61 from "./images/img61.png";
// import img62 from "./images/img62.png";
// import img7 from "./images/img7.png";
// import img71 from "./images/img71.png";

// const CARDS = [
//     { title: "WhatsApp Payments", desc: "Enable secure in-chat payments and checkout, allowing users to complete transactions without leaving WhatsApp." },
//     { title: "WhatsApp Business Calling", desc: "Seamlessly switch from chat to voice with integrated calling, making complex queries easier to resolve in real time." },
//     { title: "Click-to-WhatsApp (CTW)", desc: "Turn ads, websites or social media links into instant WhatsApp conversations, boosting lead generation and conversions." },
//     { title: "Web View", desc: "Offer immersive mini-web experiences inside WhatsApp for product details, forms or checkout flows without redirecting users." },
//     { title: "Schedule Appointments (Forms Flow)", desc: "Collect customer details, book slots and confirm appointments using guided multi-step forms directly in chat." },
//     { title: "View Catalog", desc: "Showcase your full product or service catalog inside WhatsApp with pricing and details for easy browsing and instant purchase." },
//     { title: "Carousel Messages", desc: "Send interactive, swipeable cards with images, titles and buttons—perfect for product discovery and promotions." },
//     { title: "Analytics & CRM Integration", desc: "Get real-time insights into every interaction with seamless CRM sync for streamlined workflows and smarter engagement." },
// ];

// // ====== TIMING ======
// const ENTRANCE_MS = 900;   // section fade complete ➜ sequence start
// const SUB_IMG_MS = 2500;  // each sub-image stays 1.5s before next

// // ====== SEQUENCE (order + images per card) ======
// const SEQ = [
//     { cardIdx: 0, imgs: [img1, img12, img13] },
//     { cardIdx: 2, imgs: [img2, img21] },
//     { cardIdx: 4, imgs: [img3, img31] },
//     { cardIdx: 6, imgs: [img4] },
//     { cardIdx: 1, imgs: [img5, img51] },
//     { cardIdx: 3, imgs: [img6, img61, img62] },
//     { cardIdx: 5, imgs: [img7, img71] },
//     { cardIdx: 7, imgs: [null] }, // no image for last card
// ];

// const MainWhatsApp = () => {
//     const [mounted, setMounted] = useState(false);
//     const [sequenceOn, setSequenceOn] = useState(false);

//     const [step, setStep] = useState(0);   // which card
//     const [sub, setSub] = useState(0);   // which sub-image
//     const [imgSrc, setImgSrc] = useState(null);

//     const sectionRef = useRef(null);
//     const leftColRef = useRef(null);
//     const rightColRef = useRef(null);
//     const [phoneH, setPhoneH] = useState(550);

//     // Reveal when visible
//     useEffect(() => {
//         const el = sectionRef.current;
//         if (!el) return;
//         const io = new IntersectionObserver(([entry]) => {
//             if (entry.isIntersecting) {
//                 setMounted(true);
//                 io.disconnect();
//             }
//         }, { threshold: 0.2 });
//         io.observe(el);
//         return () => io.disconnect();
//     }, []);

//     // Start sequence after entrance
//     useEffect(() => {
//         if (!mounted) return;
//         const t = setTimeout(() => {
//             setSequenceOn(true);
//             setStep(0);
//         }, ENTRANCE_MS);
//         return () => clearTimeout(t);
//     }, [mounted]);

//     // Sub-image driver
//     useEffect(() => {
//         if (!sequenceOn) return;

//         const { imgs } = SEQ[step];
//         setSub(0);
//         setImgSrc(imgs[0] ?? null);

//         let t;
//         let idx = 0;

//         const advance = () => {
//             if (idx < imgs.length - 1) {
//                 idx += 1;
//                 setSub(idx);
//                 setImgSrc(imgs[idx] ?? null);
//                 t = setTimeout(advance, SUB_IMG_MS);
//             } else {
//                 t = setTimeout(() => {
//                     setStep(prev => (prev + 1) % SEQ.length);
//                 }, SUB_IMG_MS);
//             }
//         };

//         t = setTimeout(advance, SUB_IMG_MS);
//         return () => clearTimeout(t);
//     }, [sequenceOn, step]);

//     // Height sync
//     useEffect(() => {
//         const measure = () => {
//             const lh = leftColRef.current?.offsetHeight || 0;
//             const rh = rightColRef.current?.offsetHeight || 0;
//             const h = Math.max(lh, rh);
//             if (h && h !== phoneH) setPhoneH(h);
//         };
//         const onResize = () => requestAnimationFrame(measure);
//         const id = setTimeout(measure, 0);
//         window.addEventListener("resize", onResize);
//         return () => {
//             clearTimeout(id);
//             window.removeEventListener("resize", onResize);
//         };
//     }, [phoneH]);

//     const cardStyles = {
//         background: "linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%)",
//         padding: "20px",
//         borderRadius: "8px",
//         position: "relative",
//         zIndex: 1,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//     };

//     const isCardActive = (i) => sequenceOn && i === SEQ[step].cardIdx;

//     return (
//         <section
//             ref={sectionRef}
//             className={`py-5 position-relative section-reveal ${mounted ? "show" : ""}`}
//             style={{
//                 overflow: "hidden",
//                 background: "linear-gradient(180deg, #f1f7ff 0%, #FFFFFF 100%)",
//             }}
//         >
//             <div
//                 className="px-5 x-xxl-5 px-6 mx-auto position-relative"
//                 style={{ maxWidth: "74%", zIndex: 1 }}
//             >
//                 {/* Heading */}
//                 <div className="reveal from-bottom" style={{ "--delay": "0ms" }}>
//                     <h2
//                         style={{
//                             fontSize: "2.5rem",
//                             fontFamily: "Inter",
//                             fontWeight: 700,
//                             color: "#242121ff",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Why Start with{" "}
//                         <span style={{ color: "#1DB954", fontFamily: "Inter", fontWeight: 700 }}>
//                             WhatsApp Business API?
//                         </span>
//                     </h2>
//                     <p
//                         className="mt-2"
//                         style={{
//                             marginTop: -2,
//                             color: "#413e3eff",
//                             fontSize: "1.1rem",
//                             fontFamily: "Poppins",
//                             fontWeight: 300,
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Engage smarter with features designed to convert chats into sales
//                         and customers into loyal users.
//                     </p>
//                 </div>

//                 {/* Columns + Center */}
//                 <div
//                     className="reveal from-bottom"
//                     style={{
//                         "--delay": "120ms",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         gap: "2rem",
//                         marginTop: "4rem",
//                     }}
//                 >
//                     {/* Left Column */}
//                     <div
//                         ref={leftColRef}
//                         className="reveal from-bottom"
//                         style={{
//                             "--delay": "160ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[0, 2, 4, 6].map((cardIdx) => (
//                             <div
//                                 key={cardIdx}
//                                 className={`card-animation-wrapper ${isCardActive(cardIdx) ? "active" : ""}`}
//                             >
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                             fontFamily: "Lato",
//                                         }}
//                                     >
//                                         {CARDS[cardIdx].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[cardIdx].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Center — image section */}
//                     <div
//                         className="reveal from-bottom"
//                         style={{
//                             "--delay": "220ms",
//                             flexShrink: 0,
//                             margin: "0 2rem",
//                             height: phoneH,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <div className="phone-frame" style={{ width: 350, height: phoneH }}>
//                             <div className="phone-img-overlay">
//                                 {imgSrc == null ? (
//                                     <div style={{ width: "100%", height: "100%" }} />
//                                 ) : (
//                                     <img
//                                         key={`${step}-${sub}`}
//                                         src={imgSrc}
//                                         alt={`Center ${step}-${sub}`}
//                                         className="center-img fade-scale-in"
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right Column */}
//                     <div
//                         ref={rightColRef}
//                         className="reveal from-bottom"
//                         style={{
//                             "--delay": "280ms",
//                             flex: 1,
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "2rem",
//                         }}
//                     >
//                         {[1, 3, 5, 7].map((cardIdx) => (
//                             <div
//                                 key={cardIdx}
//                                 className={`card-animation-wrapper ${isCardActive(cardIdx) ? "active" : ""}`}
//                             >
//                                 <div style={cardStyles}>
//                                     <h3
//                                         style={{
//                                             fontSize: "20px",
//                                             color: "#242121ff",
//                                             fontFamily: "Lato",
//                                             fontWeight: 600,
//                                             margin: 0,
//                                         }}
//                                     >
//                                         {CARDS[cardIdx].title}
//                                     </h3>
//                                     <p
//                                         style={{
//                                             fontSize: "1.15rem",
//                                             fontFamily: "Lato",
//                                             fontWeight: 400,
//                                             color: "#413e3eff",
//                                             margin: "8px 0 0",
//                                             lineHeight: 1.3,
//                                             wordSpacing: "2px",
//                                         }}
//                                     >
//                                         {CARDS[cardIdx].desc}
//                                     </p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Styles (unchanged) */}
//             <style>{`
//         .section-reveal {
//           opacity: 0;
//           transform: translateY(50px);
//           transition: opacity 0.8s ease, transform 0.8s ease;
//           position: relative;
//         }
//         .section-reveal.show { opacity: 1; transform: none; }

//         .reveal {
//           opacity: 0;
//           transform: translateY(24px);
//           transition: opacity .7s ease, transform .7s ease;
//           will-change: transform, opacity;
//           transition-delay: var(--delay, 0ms);
//         }
//         .section-reveal.show .reveal { opacity: 1; transform: none; }
//         .reveal.from-bottom { transform: translateY(28px); }

//         .card-animation-wrapper {
//           position: relative;
//           padding: 2px;
//           border-radius: 12px;
//           overflow: hidden;
//           transition: all 0.5s ease-in-out;
//           height: 140px;
//           will-change: transform, box-shadow;
//         }
//         .card-animation-wrapper::before,
//         .card-animation-wrapper::after { z-index: 0; }
//         .card-animation-wrapper::before {
//           content: "";
//           position: absolute;
//           inset: 0;
//           background: transparent;
//           border-radius: inherit;
//         }
//         .card-animation-wrapper.active::before {
//           background: conic-gradient(from 0deg, #4FC3FF, #2C2C6F, #4FC3FF);
//           animation: spin 2.5s linear infinite;
//         }
//         .card-animation-wrapper::after {
//           content: "";
//           position: absolute;
//           inset: 5px;
//           background: linear-gradient(135deg, #F4F7FC 0%, #ddeaffff 100%);
//           border-radius: 10px;
//           transition: background 0.5s ease-in-out;
//         }
//         .card-animation-wrapper.active {
//           animation: borderPop .45s cubic-bezier(.2,.8,.2,1) both;
//         }
//         @keyframes borderPop {
//           0%   { transform: scale(.985); box-shadow: 0 0 0 rgba(76,195,255,0); }
//           45%  { transform: scale(1.02); box-shadow: 0 12px 28px rgba(76,195,255,.25); }
//           100% { transform: scale(1);    box-shadow: 0 6px 16px rgba(0,0,0,.08); }
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }

//         .phone-frame {
//           position: relative;
//           border-radius: 10px;
//           padding: 2px;
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           background: transparent;
//         }
//         .phone-img-overlay {
//           position: relative;
//           z-index: 2;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//         }
//         .center-img {
//           width: 100%;
//           height: 100%;
//           object-fit: contain;
//           border-radius: 8px;
//           display: block;
//         }

//         .fade-scale-in { animation: fadeScaleIn 420ms cubic-bezier(.2,.8,.2,1) both; }
//         @keyframes fadeScaleIn { from { opacity: 0; transform: scale(.92); } to { opacity: 1; transform: scale(1); } }
//       `}</style>
//         </section>
//     );
// };

// export default MainWhatsApp;


import React, { useState, useEffect, useRef } from "react";

import img1 from "./images/img1.png";
import img12 from "./images/img12.png";
import img13 from "./images/img13.png";
import img2 from "./images/img2.png";
import img21 from "./images/img21.png";
import img3 from "./images/img3.png";
import img31 from "./images/img31.png";
import img4 from "./images/img4.png";
import img5 from "./images/img5.png";
import img51 from "./images/img51.png";
import img6 from "./images/img6.png";
import img61 from "./images/img61.png";
import img62 from "./images/img62.png";
import img7 from "./images/img7.png";
import img71 from "./images/img71.png";

const CARDS = [
    { title: "WhatsApp Payments", desc: "Enable secure in-chat payments and checkout, allowing users to complete transactions without leaving WhatsApp." },
    { title: "WhatsApp Business Calling", desc: "Seamlessly switch from chat to voice with integrated calling, making complex queries easier to resolve in real time." },
    { title: "Click-to-WhatsApp (CTW)", desc: "Turn ads, websites or social media links into instant WhatsApp conversations, boosting lead generation and conversions." },
    { title: "Web View", desc: "Offer immersive mini-web experiences inside WhatsApp for product details, forms or checkout flows without redirecting users." },
    { title: "Schedule Appointments (Forms Flow)", desc: "Collect customer details, book slots and confirm appointments using guided multi-step forms directly in chat." },
    { title: "View Catalog", desc: "Showcase your full product or service catalog inside WhatsApp with pricing and details for easy browsing and instant purchase." },
    { title: "Carousel Messages", desc: "Send interactive, swipeable cards with images, titles and buttons—perfect for product discovery and promotions." },
    { title: "Analytics & CRM Integration", desc: "Get real-time insights into every interaction with seamless CRM sync for streamlined workflows and smarter engagement." },
];

// ====== TIMING ======
const ENTRANCE_MS = 900;   // section fade complete ➜ sequence start
const SUB_IMG_MS = 2500;  // each sub-image stays 2.5s before next

// ====== SEQUENCE (order + images per card) ======
// ✅ Loops through cards 1–7 only; card8 excluded
const SEQ = [
    { cardIdx: 0, imgs: [img1, img12, img13] },
    { cardIdx: 2, imgs: [img2, img21] },
    { cardIdx: 4, imgs: [img3, img31] },
    { cardIdx: 6, imgs: [img4] },
    { cardIdx: 1, imgs: [img5, img51] },
    { cardIdx: 3, imgs: [img6, img61, img62] },
    { cardIdx: 5, imgs: [img7, img71] },
];

const MainWhatsApp = () => {
    const [mounted, setMounted] = useState(false);
    const [sequenceOn, setSequenceOn] = useState(false);

    const [step, setStep] = useState(0);     // which card
    const [sub, setSub] = useState(0);     // which sub-image
    const [imgSrc, setImgSrc] = useState(null);

    const sectionRef = useRef(null);
    const leftColRef = useRef(null);
    const rightColRef = useRef(null);
    const [phoneH, setPhoneH] = useState(550);

    // Reveal when visible
    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setMounted(true);
                    io.disconnect();
                }
            },
            { threshold: 0.2 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);

    // Start sequence after entrance
    useEffect(() => {
        if (!mounted) return;
        const t = setTimeout(() => {
            setSequenceOn(true);
            setStep(0);
        }, ENTRANCE_MS);
        return () => clearTimeout(t);
    }, [mounted]);

    // Sub-image driver (per step/card)
    useEffect(() => {
        if (!sequenceOn) return;

        const { imgs } = SEQ[step];
        setSub(0);
        setImgSrc(imgs[0] ?? null);

        let t;
        let idx = 0;

        const advance = () => {
            if (idx < imgs.length - 1) {
                idx += 1;
                setSub(idx);
                setImgSrc(imgs[idx] ?? null);
                t = setTimeout(advance, SUB_IMG_MS);
            } else {
                t = setTimeout(() => {
                    setStep(prev => (prev + 1) % SEQ.length);
                }, SUB_IMG_MS);
            }
        };

        t = setTimeout(advance, SUB_IMG_MS);
        return () => clearTimeout(t);
    }, [sequenceOn, step]);

    // Height sync
    useEffect(() => {
        const measure = () => {
            const lh = leftColRef.current?.offsetHeight || 0;
            const rh = rightColRef.current?.offsetHeight || 0;
            const h = Math.max(lh, rh);
            if (h && h !== phoneH) setPhoneH(h);
        };
        const onResize = () => requestAnimationFrame(measure);
        const id = setTimeout(measure, 0);
        window.addEventListener("resize", onResize);
        return () => {
            clearTimeout(id);
            window.removeEventListener("resize", onResize);
        };
    }, [phoneH]);

    const cardStyles = {
        background: "linear-gradient(135deg, #F4F7FC 0%, #DDEAFF 100%)",
        padding: "20px",
        borderRadius: "8px",
        position: "relative",
        zIndex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    };

    const isCardActive = (i) => sequenceOn && i === SEQ[step].cardIdx;

    return (
        <section
            ref={sectionRef}
            className={`py-5 position-relative section-reveal ${mounted ? "show" : ""}`}
            style={{
                overflow: "hidden",
                background: "linear-gradient(180deg, #f1f7ff 0%, #FFFFFF 100%)",
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{ maxWidth: "74%", zIndex: 1 }}
            >
                {/* Heading */}
                <div className="reveal from-bottom" style={{ "--delay": "0ms" }}>
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Why Start with{" "}
                        <span style={{ color: "#1DB954", fontFamily: "Inter", fontWeight: 700 }}>
                            WhatsApp Business API?
                        </span>
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Engage smarter with features designed to convert chats into sales
                        and customers into loyal users.
                    </p>
                </div>

                {/* Columns + Center */}
                <div
                    className="reveal from-bottom"
                    style={{
                        "--delay": "120ms",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "2rem",
                        marginTop: "4rem",
                    }}
                >
                    {/* Left Column */}
                    <div
                        ref={leftColRef}
                        className="reveal from-bottom"
                        style={{
                            "--delay": "160ms",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "2rem",
                        }}
                    >
                        {[0, 2, 4, 6].map((cardIdx) => (
                            <div
                                key={cardIdx}
                                className={`card-animation-wrapper ${isCardActive(cardIdx) ? "active" : ""}`}
                            >
                                <div style={cardStyles}>
                                    <h3
                                        style={{
                                            fontSize: "20px",
                                            color: "#242121ff",
                                            fontWeight: 600,
                                            margin: 0,
                                            fontFamily: "Lato",
                                        }}
                                    >
                                        {CARDS[cardIdx].title}
                                    </h3>
                                    <p
                                        style={{
                                            fontSize: "1.15rem",
                                            fontFamily: "Lato",
                                            fontWeight: 400,
                                            color: "#413e3eff",
                                            margin: "8px 0 0",
                                            lineHeight: 1.3,
                                            wordSpacing: "2px",
                                        }}
                                    >
                                        {CARDS[cardIdx].desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Center — image section */}
                    <div
                        className="reveal from-bottom"
                        style={{
                            "--delay": "220ms",
                            flexShrink: 0,
                            margin: "0 2rem",
                            height: phoneH,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div className="phone-frame" style={{ width: 350, height: phoneH }}>
                            <div className="phone-img-overlay">
                                {imgSrc == null ? (
                                    <div style={{ width: "100%", height: "100%" }} />
                                ) : (
                                    <img
                                        key={`${step}-${sub}`}
                                        src={imgSrc}
                                        alt={`Center ${step}-${sub}`}
                                        className="center-img fade-scale-in"
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div
                        ref={rightColRef}
                        className="reveal from-bottom"
                        style={{
                            "--delay": "280ms",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "2rem",
                        }}
                    >
                        {[1, 3, 5, 7].map((cardIdx) => (
                            <div
                                key={cardIdx}
                                className={`card-animation-wrapper ${isCardActive(cardIdx) ? "active" : ""}`}
                            >
                                <div style={cardStyles}>
                                    <h3
                                        style={{
                                            fontSize: "20px",
                                            color: "#242121ff",
                                            fontFamily: "Lato",
                                            fontWeight: 600,
                                            margin: 0,
                                        }}
                                    >
                                        {CARDS[cardIdx].title}
                                    </h3>
                                    <p
                                        style={{
                                            fontSize: "1.15rem",
                                            fontFamily: "Lato",
                                            fontWeight: 400,
                                            color: "#413e3eff",
                                            margin: "8px 0 0",
                                            lineHeight: 1.3,
                                            wordSpacing: "2px",
                                        }}
                                    >
                                        {CARDS[cardIdx].desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Styles */}
            <style>{`
        .section-reveal {
          opacity: 0;
          transform: translateY(50px);
          transition: opacity 0.8s ease, transform 0.8s ease;
          position: relative;
        }
        .section-reveal.show { opacity: 1; transform: none; }

        .reveal {
          opacity: 0;
          transform: translateY(24px);
          transition: opacity .7s ease, transform .7s ease;
          will-change: transform, opacity;
          transition-delay: var(--delay, 0ms);
        }
        .section-reveal.show .reveal { opacity: 1; transform: none; }
        .reveal.from-bottom { transform: translateY(28px); }

        .card-animation-wrapper {
          position: relative;
          padding: 2px;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.5s ease-in-out;
          height: 140px;
          will-change: transform, box-shadow;
        }
        .card-animation-wrapper::before,
        .card-animation-wrapper::after { z-index: 0; }
        .card-animation-wrapper::before {
          content: "";
          position: absolute;
          inset: 0;
          background: transparent;
          border-radius: inherit;
        }
        .card-animation-wrapper.active::before {
          background: conic-gradient(from 0deg, #4FC3FF, #2C2C6F, #4FC3FF);
          animation: spin 2.5s linear infinite;
        }
        .card-animation-wrapper::after {
          content: "";
          position: absolute;
          inset: 5px;
          background: linear-gradient(135deg, #F4F7FC 0%, #DDEAFF 100%);
          border-radius: 10px;
          transition: background 0.5s ease-in-out;
        }
        .card-animation-wrapper.active {
          animation: borderPop .45s cubic-bezier(.2,.8,.2,1) both;
        }
        @keyframes borderPop {
          0%   { transform: scale(.985); box-shadow: 0 0 0 rgba(76,195,255,0); }
          45%  { transform: scale(1.02); box-shadow: 0 12px 28px rgba(76,195,255,.25); }
          100% { transform: scale(1);    box-shadow: 0 6px 16px rgba(0,0,0,.08); }
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        .phone-frame {
          position: relative;
          border-radius: 10px;
          padding: 2px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: transparent;
        }
        .phone-img-overlay {
          position: relative;
          z-index: 2;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .center-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
          display: block;
        }

        .fade-scale-in { animation: fadeScaleIn 420ms cubic-bezier(.2,.8,.2,1) both; }
        @keyframes fadeScaleIn { from { opacity: 0; transform: scale(.92); } to { opacity: 1; transform: scale(1); } }
      `}</style>
        </section>
    );
};

export default MainWhatsApp;

